import { prettify, renderEUDateTime } from "../../../utils/utils";
import { Done as DoneIcon, Close as CloseIcon } from "@mui/icons-material";

const errorValue = {
  sx: {
    color: "black",
  },
};

export const commonColumns = [
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) => prettify(row.origin),
    header: "Dispositivo",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) => renderEUDateTime(row.data.Date),
    // accessorFn: (row) => renderEUDateTime(row.date),
    header: "Data di rilevazione",
  },
  {
    size: 5,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Alert",
    accessorFn: (row) => (row.alert ? true : false),
    Cell: ({ cell }) =>
      cell.getValue() === true ? (
        <CloseIcon color="error" />
      ) : (
        <DoneIcon color="success" />
      ),
  },
];

export const pressureColumns = [
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.Pmin === null || row.data.Pmin === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.Pmin}`,
    header: "Pressione Diastolica",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.Pmax === null || row.data.Pmax === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.Pmax}`,
    header: "Pressione Sistolica",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.HR === null || row.data.HR === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.HR}bpm`,
    header: "Freq. Cardiaca",
  },
];

export const temperatureColumns = [
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.Temperature === null
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.Temperature}°C`,
    header: "Temperatura",
  },
];

export const spo2Columns = [
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.Duration === null || row.data.Duration === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.Duration}s`,
    header: "Durata",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.SPO2 === null || row.data.SPO2 === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.SPO2}`,
    header: "SPO2 Media",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.SPO2_min === null || row.data.SPO2_min === undefined
        ? row.origin.toLowerCase() === "butterflife"
          ? ""
          : "PARAMETRO NON RILEVATO"
        : `${row.data.SPO2_min}`,
    header: "SPO2 Minima",
  },
];

export const ecgColumns = [
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.Duration === null || row.data.Duration === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.Duration}s`,
    header: "Durata",
  },
  {
    size: 50,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, table }) =>
      cell.getValue() === "PARAMETRO NON RILEVATO"
        ? errorValue
        : cell.getValue(),
    accessorFn: (row) =>
      row.data.HR === null || row.data.Duration === undefined
        ? "PARAMETRO NON RILEVATO"
        : `${row.data.HR}bpm`,
    header: "Freq. Cardiaca",
  },
];
